import { HttpResponse } from '@angular/common/http';

import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';

import { ApiBaseMidBack } from './base';
import { DownloadUserCurvesCsvRequest } from './types/downloadUserCurvesCsvRequest';
import { DownloadUserCurvesExcelRequest } from './types/downloadUserCurvesExcelRequest';

/**
 * @internal
 */
export class ApiUserCurves extends ApiBaseMidBack {
  @ApiOptions({ channel: 'userCurves.series.download', responseType: 'blob', responseObserve: 'response' })
  downloadAllUserCurvesInOneExcel(body: DownloadUserCurvesExcelRequest[]) {
    return this.post<HttpResponse<Blob>>('/user-curves/download-user-curves/excel', new DefaultParams(body));
  }

  @ApiOptions({ responseType: 'text' })
  getUserCurvesCSV(body: DownloadUserCurvesCsvRequest) {
    return this.post<string>('/user-curves/download-user-curves/csv', new DefaultParams(body));
  }
}
